export enum LogsActionTypes {
  GET_LIST_LOGS = "LOGS_GET_LIST",
  GET_LIST_LOGS_SUCCESS = "LOGS_GET_LIST_SUCCESS",
  GET_LIST_LOGS_ERROR = "LOGS_GET_LIST_ERROR",
  GET_LOG = "GET_LOG",
  GET_LOG_SUCCESS = "GET_LOG_SUCCESS",
  GET_LOG_ERROR = "GET_LOG_ERROR",
}
